export enum SituacaoEnum {
  rascunho = 'rascunho',
  finalizado = 'finalizado'
}

